import {FC} from "react";
import {useTranslation} from "react-i18next";
import {useFlags} from "launchdarkly-react-client-sdk";
import {useAnalytics} from "@common-core/react-analytics";
import {Button} from "@interstate/components/Button";
import {useNavigation} from "../../navigation";
import {useClientEntity} from "../context";

export const CreateOperationalEntityButton: FC = () => {
  const {t} = useTranslation();
  const flags = useFlags();
  const {entity} = useClientEntity();
  const {navigateTo} = useNavigation();
  const {productEvent} = useAnalytics();
  return (
    <Button
      id={`entity-create-button-${entity.caId}`}
      data-testid={`entity-create-button-${entity.caId}`}
      className={"entity-create-button"}
      buttonStyle={"primary"}
      onClick={(event: any) => {
        productEvent({
          name: "create_operational_entity",
          properties: {
            location: "Client Hierarchy Page",
            value: `${entity.caId}`,
            result: `${entity.caId}`
          }
        });
        navigateTo(event, `/create-operational-entity/${entity.caId}`);
      }}>
      {t("entity-detail.create-button-text")}
    </Button>
  );
};
